export { SuiPopupModule, SuiPopupConfig, PopupTrigger } from "./index";
import { PositioningPlacement } from "../../misc/util/index";
export { PositioningPlacement as PopupPlacement };
